import React from "react"
import { get, isArray, map } from "lodash"
import APIs from "redux/apis"
import { APIResponse } from "redux/apis/types"
import uuid from "uuid"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"

/*******************************
 * トップ＞ワールドサマリ＞経済指標
 *******************************/

type apiParamList =
  | "Top.Summary.Jpn.Today"
  | "Top.Summary.Jpn.PrevDays"
  | "Top.Summary.Jpn.NextDays"
  | "Top.Summary.Jpn.CurMonth"
  | "Top.Summary.Asian.Today"
  | "Top.Summary.Asian.PrevDays"
  | "Top.Summary.Asian.NextDays"
  | "Top.Summary.Asian.CurMonth"
  | "Top.Summary.Other.Today"
  | "Top.Summary.Other.PrevDays"
  | "Top.Summary.Other.NextDays"
  | "Top.Summary.Other.CurMonth"
  | "Top.Summary.All.Today"
  | "Top.Summary.All.PrevDays"
  | "Top.Summary.All.NextDays"
  | "Top.Summary.All.CurMonth"
  | "Top.Indicator.Today"
  | "Top.Indicator.PrevDays"
  | "Top.Indicator.NextDays"
  | "Top.Indicator.CurMonth"
  | "Top.Indicator.Month"
  | "Top.Indicator.Group"

type domesticApiParamList = [
  "Country.JP.Today",
  "Country.JP.PrevDays",
  "Country.JP.NextDays"
]

type Props = {
  displayPeriodNum?: number
  indicatorTypeNum?: number
  selectMonthNum?: number
  industryNum?: number
  apiParam: apiParamList | domesticApiParamList | {}
  changeIndicatorList: Function
}

//API
export const indicatorListApi = async (props: Props) => {
  const loadResistId = uuid()
  store.dispatch(pageLoadRegist(loadResistId, true))
  if (isArray(props.apiParam)) {
    const apiRes: APIResponse.Res = await Promise.all(
      map(props.apiParam, async param => {
        const ranking:
          | APIResponse.Res
          | {} = await APIs.SymbolDetail.IndicatorList({
          Name: param,
        })
        return get(ranking, "ResultList")
      })
    )
    props.changeIndicatorList({
      indicatorListTodayData: apiRes[0],
      indicatorListPrevDayData: apiRes[1],
      indicatorListNextDayData: apiRes[2],
    })
    store.dispatch(pageLoadRegist(loadResistId, false))
  } else {
    const indicatorList:
      | APIResponse.Res
      | {} = await APIs.SymbolDetail.IndicatorList({
      Name: props.apiParam,
    })
    const resultList = get(indicatorList, "ResultList", [])
    props.changeIndicatorList({
      apiRes: resultList,
      indicatorTypeNum: props.indicatorTypeNum,
      displayPeriodNum: props.displayPeriodNum,
      selectMonthNum: props.selectMonthNum,
      industryNum: props.industryNum,
    })
    store.dispatch(pageLoadRegist(loadResistId, false))
  }
}
